import { FC } from "react";
import {
  Typography,
  Box,
  useMediaQuery,
  Button,
  makeStyles,
  Container,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import Fail from "../../assets/images/fail.png";
import { useHistory } from "react-router";

const useStyles = makeStyles((theme) => ({
  congrats: {
    "& br": {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
  },
  longbtn: {
    paddingRight: theme.spacing(6),
    paddingLeft: theme.spacing(6),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      minWidth: "100%",
    },
  },
}));
const WhitelistFail: FC = () => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Container fixed>
        <Box
          mt={isActive ? 3 : 5}
          ml={isActive ? 0 : 0}
          display="flex"
          flexDirection="column"
          alignItems="center"
          component="section"
          className={classes.congrats}
        >
          <Box>
            <img src={Fail} alt="gains" className="img-fluid" />
          </Box>
          <Box mt={4} mb={isActive ? 1 : 2}>
            <Typography variant="h2" color="primary">
              Sorry
            </Typography>
          </Box>

          <Typography variant="body1" align="center" className="body-color">
            You are not able to complete the whitelist process for this
            Project.
          </Typography>
        </Box>
        <Box mt={isActive ? 4 : 5} mb={isActive ? 3 : 10} textAlign="center">
            <Button
              variant="outlined"
              color="secondary"
              className={`${classes.longbtn}`}
              onClick={() => history.push('/deals')}
            >
              back to main menu
            </Button>
        </Box>
      </Container>
    </>
  );
};

export default WhitelistFail;
